import { render, staticRenderFns } from "./actas-general.vue?vue&type=template&id=305c27c1&"
import script from "./actas-general.vue?vue&type=script&lang=js&"
export * from "./actas-general.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports